import React from 'react'

class CardSelectable extends React.Component {

  render() {
    return(
      <div
        className="card card-selectable"
        onMouseEnter={(e) => this.props.onMouseEnter(e) }
        onMouseLeave={() => this.props.onMouseLeave() }
        onClick={ () => this.props.onClick('refinance') }
      >
        <div className='card-body'>
          { this.props.children }
        </div>
      </div>
    )
  }
}

export default CardSelectable;
